import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Form, Formik, Field } from "formik";
import { PasswordUpdateSchema } from "../../utils/validation";
import { changePassword, resetUser } from "../../redux/Actions/SingleUserActions";
import Alert from "../../utils/Alert";
import UserModal from "../../components/EmailModal/UserModal";
import ModalInput from "../../components/FormInput/ModalInput";
import { PropTypes } from "prop-types";

const UserSettingsActions = ({
  showModal,
  hideModal,
  changePassword,
  isChanging,
  changePasswordSuccess,
  resetUser
}) => {
  const [state, setState] = useState({
    hide: true,
    hide2: true
  });

  useEffect(
    () => {
      if (changePasswordSuccess) {
        Alert(true, "success", "Success message", "Password changed successfully.");
        document.getElementById("form").reset();
        hideModal();
        resetUser();
      }
    },
    // eslint-disable-next-line
    [changePasswordSuccess]
  );

  const handleClick = () => {
    setState({
      ...state,
      hide: !state.hide,
    });
  };

  const handleClick2 = () => {
    setState({
      ...state,
      hide2: !state.hide2,
    });
  };

  return (
    <div>
      <UserModal
        open={showModal}
        close={hideModal}
        height={"597"}
        width={"555"}
      >
        <div className="modal-header">
          <h1>CHANGE PASSWORD</h1>
        </div>

        <div>
          <Formik
            initialValues={{
              oldPassword: "",
              newPassword: ""
            }}
            onSubmit={(values) => {
              changePassword(values);
            }}
            validationSchema={PasswordUpdateSchema}
          >
            {({ isValid, dirty }) => {
              return (
                <Form id="form">
                  <div className="modal-form">
                    <div className="modal-input-password">
                      <span onClick={handleClick}>
                        {state.hide ? "SHOW" : "HIDE"}
                      </span>
                      <Field
                        name="oldPassword"
                        label="Old Password"
                        placeholder="Enter old password"
                        type={state.hide ? "password" : "text"}
                        component={ModalInput}
                      />
                    </div>

                    <br/>
                    <div className="modal-input-password">
                      <span onClick={handleClick2}>
                        {state.hide2 ? "SHOW" : "HIDE"}
                      </span>
                      <Field
                        name="newPassword"
                        label="New Password"
                        placeholder="Enter new password"
                        type={state.hide2 ? "password" : "text"}
                        component={ModalInput}
                      />
                    </div>

                    <br/>
                    <br/>
                    <br/>
                    <div className="form-grid-4">
                      <div className="modal-input-button">
                        <button
                          className="modal-close-button"
                          onClick={hideModal}
                          type="button"
                        >
                          CANCEL
                        </button>
                      </div>

                      <div className="modal-input-button">
                        <button
                          type="submit"
                          className="modal-action-button"
                          disabled={isChanging || !(isValid && dirty)}
                        >
                          CHANGE
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </UserModal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  changePassword: (password) => dispatch(changePassword(password)),
  resetUser: () => dispatch(resetUser()),
});

const mapStateToProps = (state) => ({
  isChanging: state.singleStaff.isChanging,
  changePasswordSuccess: state.singleStaff.changePasswordSuccess
});

UserSettingsActions.propTypes = {
  showModal: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func
  ]),
  hideModal: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func
  ]),
  changePassword: PropTypes.func,
  isChanging: PropTypes.bool,
  changePasswordSuccess: PropTypes.bool,
  resetUser: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSettingsActions);
